/** Max dashboard items attachable to a single chat message (@ picker + API). */
export const MAX_DASHBOARD_CONTEXT_BOARDS = 1;
export const MAX_DASHBOARD_CONTEXT_CARDS = 3;

export function countBoardAttachments(list) {
  return (list || []).filter((a) => a?.kind === 'board').length;
}

export function countCardAttachments(list) {
  return (list || []).filter((a) => a?.kind === 'card').length;
}

/** Keep first N boards (1) and first M cards (3) in client order. */
export function capDashboardAttachments(list) {
  let boards = 0;
  let cards = 0;
  const out = [];
  for (const a of list || []) {
    if (!a || (a.kind !== 'board' && a.kind !== 'card')) continue;
    if (a.kind === 'board') {
      if (boards >= MAX_DASHBOARD_CONTEXT_BOARDS) continue;
      boards += 1;
      out.push(a);
    } else {
      if (cards >= MAX_DASHBOARD_CONTEXT_CARDS) continue;
      cards += 1;
      out.push(a);
    }
  }
  return out;
}
